import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css'; // Import global CSS

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
   // Remove StrictMode after development
   //<React.StrictMode>
   <App />
   // </React.StrictMode>
);
